<template>
    <nav class="navbar navbar-default">
<div class="container-fluid">

<!-- BRAND -->
<div class="navbar-header">
<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#alignment-example" aria-expanded="false">
<span class="sr-only">Toggle navigation</span>
<span class="icon-bar"></span>
<span class="icon-bar"></span>
<span class="icon-bar"></span>
</button>
<!-- <a class="navbar-brand" href="#">Your Brand</a> -->
</div>

<!-- COLLAPSIBLE NAVBAR -->
<div class="collapse navbar-collapse" id="alignment-example">

<!-- Links -->
<ul class="nav navbar-nav">
<li><a href="#">Home</a></li>
<li><a href="#">Parenting</a></li>
<li class="dropdown">
<a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Aging <span class="caret"></span></a>
<ul class="dropdown-menu" aria-labelledby="about-us">
<li><a href="#">Our Story</a></li>
<li><a href="#">Our Team</a></li>
<li><a href="#">Contact Us</a></li>
</ul>
</li>
<li><a href="#">Balancing</a></li>
<li><a href="#">Thriving</a></li>
<li><a href="#">Working</a></li>
<li><a href="#">Living</a></li>
<li><a href="#">International</a></li>
</ul>


</div>

</div>
</nav>

</template>

<script>

    export default{
        name:'MainMenuPages',

        computed:{
            menuItems(){
                //console.log(this.$store.state.menuVar);
                return this.$store.state.menuVar;
                },
            languageData(){return this.$store.state.languageData;}
        },

        components: {
        
        },  
          
        mounted:function(){
            this.showMenu()
        },
        methods: {
            showMenu(){
                this.$store.dispatch('getMenu');
                //console.log('homeContent'+state.content);
            }
        }
    }; 
</script>

<style scoped>

.navbar {
    border-radius: 0px;
    margin-bottom: 0px;
    border: none;
    border-left: 1px solid #dcdcdc5e;
    border-right: 1px solid #dcdcdc5e;
}
.container-fluid {
    padding: 0;
}
</style>
